import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "/novagenix-logo.png";

// Convert relative /api/files/... paths to absolute URLs against the backend.
// Local /products/* assets live in the frontend public folder — keep them same-origin.
export const resolveImg = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/products/")) return url;
  return `${BACKEND_URL}${url}`;
};

// Currency formatter — Australian dollars
export const CURRENCY = "AUD";
export const CURRENCY_SYMBOL = "A$";
export const fmt = (n) => `${CURRENCY_SYMBOL}${Number(n || 0).toFixed(2)}`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ngx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
